/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2022-09-01 10:51:26
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-13 15:43:19
 */
import type { Reducer, Effect } from 'umi'

import { queryTaskList } from '@/services/interact'

export interface StateType {
  status?: 'ok' | 'error'
}

export interface MySpaceState {
  taskList: any[]
}

export interface myTaskModelType {
  namespace: string
  state: MySpaceState
  effects: {
    getTaskList: Effect
  }
  reducers: {
    saveTaskList: Reducer
  }
}

const myTaskModel: myTaskModelType = {
  namespace: 'mySpace',

  state: {
    taskList: []
  },

  effects: {
    *getTaskList({ payload }, { call, put }) {
      const res = yield call(queryTaskList, payload)
      if (res.code === 0) {
        yield put({
          type: 'saveTaskList',
          payload: res.data
        })
      }
    }
  },

  reducers: {
    saveTaskList(state, { payload }) {
      return {
        ...state,
        taskList: payload
      }
    }
  }
}

export default myTaskModel
